import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Button, Collapse, Flex, Text } from 'core/components';
import SudoTag from 'app/components/SudoTag';
import { InputGroup } from 'core/form';
import KaizenChatList from './KaizenChatList';
import { KaizenSidebar as StyledKaizenSidebar, SmallHeading } from './KaizenChatSession.styles';

@inject('$auth', '$journeys')
@withRouter
@observer
class KaizenSidebar extends Component {
  state = {
    isMyJourneysOpen: true,
    isCompanyJourneysOpen: true,
    searchInputValue: ''
  };

  handleToggleMyJourneys = () => {
    this.setState((prevState) => ({
      isMyJourneysOpen: !prevState.isMyJourneysOpen
    }));
  };

  handleToggleCompanyJourneys = () => {
    this.setState((prevState) => ({
      isCompanyJourneysOpen: !prevState.isCompanyJourneysOpen
    }));
  };

  handleSearchInputChange = (e) => {
    const { $journeys } = this.props;
    const { value = '' } = e.target;
    this.setState({ searchInputValue: value });
    $journeys.chatSessionCollection.searchChats(value);
  };

  handleSelectJourney = (journey) => {
    const { history, $journeys, onSelectJourney } = this.props;
    if (onSelectJourney) {
      onSelectJourney(journey);
    } else {
      // Fallback to default behavior
      history.push(`${$journeys.baseUrl}/${journey.id}`);
      journey.selectAndSubscribe({ fetch: true });
    }
  };

  handleViewPrompt = () => {
    window.open('/api/ui/kaizen/context', '_blank');
  };

  render() {
    const { $auth, $journeys } = this.props;
    const { isMyJourneysOpen, isCompanyJourneysOpen, searchInputValue } = this.state;
    const { isSudoer } = $auth;

    return (
      <StyledKaizenSidebar borderLeft="thin">
        <InputGroup
          autoFocus
          leftIcon="search"
          placeholder="Search..."
          value={searchInputValue}
          onChange={this.handleSearchInputChange}
          type="search"
        />

        <Flex flexDirection="column" gap={1}>
          <Button
            textAlign="left"
            fill
            icon={isMyJourneysOpen ? 'caret-down' : 'caret-right'}
            minimal
            onClick={this.handleToggleMyJourneys}
          >
            <SmallHeading>Recent</SmallHeading>
          </Button>
          <Collapse isOpen={isMyJourneysOpen}>
            <KaizenChatList
              onSelectJourney={this.handleSelectJourney}
              hideUserName
              hideShareLevel
              hideEditedDate={false}
              journeys={$journeys.chatSessionCollection.userChats}
              maxInitialItems={10}
            />
          </Collapse>
        </Flex>

        <Flex flexDirection="column" gap={1}>
          <Button
            textAlign="left"
            fill
            icon={isCompanyJourneysOpen ? 'caret-down' : 'caret-right'}
            minimal
            onClick={this.handleToggleCompanyJourneys}
          >
            <SmallHeading>Company</SmallHeading>
          </Button>
          <Collapse isOpen={isCompanyJourneysOpen}>
            <KaizenChatList
              onSelectJourney={this.handleSelectJourney}
              hideEditedDate
              hideShareLevel
              journeys={$journeys.chatSessionCollection.companyChats}
              maxInitialItems={10}
            />
          </Collapse>
        </Flex>
        {isSudoer ? (
          <Button alignItems="center" justifyContent="center" onClick={this.handleViewPrompt}>
            <Text>
              <SudoTag fontSize={11} /> View system prompt
            </Text>
          </Button>
        ) : null}
      </StyledKaizenSidebar>
    );
  }
}

export default KaizenSidebar;
